import React from 'react';
import PropTypes from 'prop-types';

const InnerBackground = (props) => {
    const { fillColor, className } = props;
    return (
        <svg className={className} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ padding: 2 }}>
            <title>icon-fill-colour-inner</title>
            <desc>Created with Sketch.</desc>
            <g id="icon-fill-colour-inner" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icons-/-Custom-/-Fill-Colour-Inner" transform="translate(-4.000000, -4.000000)">
                    <rect id="icn-bg" fillOpacity="0" fill="#FFFFFF" x="0" y="0" width="32" height="32" />
                    <rect id="bar-right" fill="#727273" x="22" y="9" width="2" height="14" />
                    <rect id="fill-center" stroke="#727273" strokeWidth="1.5" fill={fillColor} x="13.75" y="9.75" width="4.5" height="12.5" />
                    <rect id="bar-left" fill="#727273" x="8" y="9" width="2" height="14" />
                </g>
            </g>
        </svg>
    );
};

InnerBackground.propTypes = {
    fillColor: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};

export default InnerBackground;
